// Weekly streak math shared by the fitness dashboard and the progress page.

export const pad = (n) => String(n).padStart(2, "0");

export const shiftDay = (iso, n) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Monday of the week containing the given day
export const weekStart = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const buildByDate = (acts) => {
  const m = {};
  acts.forEach((a) => {
    (m[a.date] = m[a.date] || []).push(a);
  });
  return m;
};

// Garmin-style streak: consecutive WEEKS with at least one activity
export const buildStreaks = (byDate, lastDay) => {
  const days = Object.keys(byDate);
  const weeks = [...new Set(days.map(weekStart))].sort();
  let longest = 0;
  let run = 0;
  let prev = null;
  weeks.forEach((w) => {
    run = prev && shiftDay(prev, 7) === w ? run + 1 : 1;
    if (run > longest) longest = run;
    prev = w;
  });
  // the week in progress counts if it already has a session,
  // otherwise start counting from last week
  const wset = new Set(weeks);
  const thisWeek = weekStart(lastDay);
  let current = 0;
  let cursor = wset.has(thisWeek) ? thisWeek : shiftDay(thisWeek, -7);
  while (wset.has(cursor)) {
    current += 1;
    cursor = shiftDay(cursor, -7);
  }
  return { longest, current, activeDays: days.length };
};
